import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  public async getAllParams() {
    let params = {};
    await this.activatedRoute.queryParams.subscribe(_params => {
      params = _params;
    });
    return params;
  }

  public async openPageByUrl(url = '/', params?: {}) {
    return this.router.navigate([url.toLowerCase()], {
      queryParams: params
    }).then();
  }

  public goBack(backUrl: string | undefined): void {
    if (backUrl)
      this.router.navigateByUrl(backUrl.toLowerCase(), {}).then();
    else
      this.location.back();
  }
}
